import * as PlayerApi from "@/api/player.api";
import mime from "mime";

export function createPlaylist(files) {
    const playlist = [];

    for (const file of files) {
        const type = mime.getType(file.name)?.toLowerCase() || "";
        if (!type.includes("video") && !type.includes("audio")) {
            continue;
        }

        playlist.push({
            id: file.id,
            path: file.path,
            name: file.name,
            isFile: file.isFile,
            meta: { ...file.meta }
        });
    }

    return playlist;
}

export async function playFile(file) {
    const token = await PlayerApi.createLinkToken(file.name, file.path);

    return {
        id: file.id,
        path: file.path,
        name: file.name,
        isFile: file.isFile,
        meta: {
            ...file.meta
        },
        urlToken: token
    };
}

export function shufflePlaylist(playlist) {
    const result = [...playlist];
    for (let i = result.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [result[i], result[j]] = [result[j], result[i]];
    }

    return result;
}

export async function playShareFile(file, shareToken, dir) {
    const urlToken = await PlayerApi.createShareLinkToken(
        file.name,
        shareToken,
        dir
    );

    return {
        name: file.name,
        isFile: true,
        meta: {
            ...file.meta
        },
        urlToken
    };
}